/* tslint:disable:variable-name */
export default class GeofenceStyleModel {
    bg_card_enter: string = 'success'
    bg_card_exit: string = 'danger'
}
